// 公共信息页面
const pubPages = [
    {
        path: "/enterpriseRegister",
        name: "EnterpriseRegister",
        component: () => import("@/views/pub/EnterpriseRegister"),
        meta: { menuName: "企业注册" }
    },
    {
        path: "/enterpriseInfo",
        name: "EnterpriseInfo",
        component: () => import("@/views/pub/EnterpriseIndex"),
        meta: { menuName: "企业相关信息" }
    },
    {
        path: "/applyToOrg",
        name: "ApplyToOrg",
        component: () => import("@/views/pub/ApplyToOrg"),
        meta: { menuName: "申请成为服务机构" }
    },
    {
        path: "/orgInfo",
        name: "OrgInfo",
        component: () => import("@/views/pub/OrgIndex"),
        meta: { menuName: '服务机构相关信息' }
    },
    {
        path: "/platformInfo",
        name: "PlatformInfo",
        component: () => import("@/views/pub/PlatformInfo"),
        meta: { menuName: "窗口平台相关信息" }
    },
    {
        path: "/myServiceOrg",
        name: "MyServiceOrg",
        component: () => import("@/views/pub/MyOrg"),
        meta: { menuName: "我的服务机构" }
    },
    {
        path: "/myEnterprise",
        name: "MyEnterprise",
        component: () => import("@/views/pub/MyEnterprise"),
        meta: { menuName: "我服务的企业" }
    },
    {
        path: "/orgInPltf",
        name: "OrgInPltf",
        component: () => import("@/views/pub/OrgInPltf"),
        meta: { menuName: "入驻服务机构管理" }
    },
    {
        path: "/entInPltf",
        name: "EntInPltf",
        component: () => import("@/views/pub/EntInPltf"),
        meta: { menuName: "入驻企业管理" }
    },
    {
        path: "/auditOrgInPltf",
        name: "AuditOrgInPltf",
        component: () => import("@/views/pub/AuditOrgInPltf"),
        meta: { menuName: "入驻服务机构审核" }
    },
    {
        path: "/auditEntInPltf",
        name: "AuditEntInPltf",
        component: () => import("@/views/pub/AuditEntInPltf"),
        meta: { menuName: "入驻企业审核" }
    },
    {
        path: "/auditNewEnt",
        name: "AuditNewEnt",
        component: () => import("@/views/pub/AuditNewEnt"),
        meta: { menuName: "注册企业审核" }
    },
    {
        path: "/auditNewEntUser",
        name: "AuditNewEntUser",
        component: () => import("@/views/pub/AuditNewEntUser"),
        meta: { menuName: "注册账号审核" }
    },
];

export default pubPages;
